












































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { onMounted, Ref, ref } from "@vue/composition-api";
import { UseLoading } from "@/common/composition/loading";
import { get_justification_by_id } from "@/views/customize/in-motion/justification/data/api";
import { JustificationRequest } from "@/views/customize/in-motion/justification/data/model";
import { eventParser } from "@/gql/event-parser";
import { SharedState } from "@/common/state";
import { InformationType, InfoTypeHelper } from "@/common/models";
import { getEventById } from "@/common/api/entities.api";

export default Vue.extend({
  components: {
    Modal,
  },
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      height: "auto",
      withTopRightCloseBtn: true,
    };

    const justification: Ref<JustificationRequest | null> = ref(null);
    const event_info: Ref<{
      exposed_to: string[];
      exposed_by: string;
      labels: Array<{ code: number; name: string }>;
    }> = ref({
      exposed_to: [],
      exposed_by: "",
      labels: [],
    });

    const [is_loading, set_loading] = UseLoading(false).as_arr();

    const load_justification = async (id: string) => {
      set_loading(true);
      const res = await get_justification_by_id(id);
      if (res.success) {
        justification.value = res.value.request;
      }
      set_loading(false);
    };

    onMounted(async () => {
      // @ts-ignore
      const justification_id: string = props.modalData.id;
      // @ts-ignore
      const event_id: string = props.modalData.event_id;
      if (justification_id) {
        await load_justification(justification_id);
      } else {
        // @ts-ignore
        justification.value = props.modalData.justification;
      }
      const event_res = await getEventById(event_id);
      if (event_res.success) {
        const parsed_event = eventParser(event_res.value);
        console.log("parsed_event : ", parsed_event);
        event_info.value = {
          // @ts-ignore
          exposed_to: parsed_event.exposedTo.map((d) => d.email || d.name),
          exposed_by:
            // @ts-ignore
            parsed_event.exposedBy.name || parsed_event.exposedBy.email,
          // @ts-ignore
          labels: parsed_event.items.map((item: any) => {
            const label =
              SharedState.allInfoTypes.value[item.labels.infoLabel.id];
            return {
              ...label,
              code: label?.code,
            };
          }),
        };
      }
    });

    return {
      config,
      is_loading,
      justification,
      event_info,
    };
  },
});
